import { render, staticRenderFns } from "./fwry.vue?vue&type=template&id=eded4aa8&scoped=true&"
import script from "./fwry.vue?vue&type=script&lang=js&"
export * from "./fwry.vue?vue&type=script&lang=js&"
import style0 from "./fwry.vue?vue&type=style&index=0&id=eded4aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eded4aa8",
  null
  
)

export default component.exports